import NumberFormat from 'react-number-format';
import { useListVehiclesHighestBid } from '../hooks';
import styled from 'styled-components';
import { convertToLocalTime } from '../../../../utils';
import { AUCTION_TYPES } from '../../../../constants';
import moment from 'moment';
import { ButtonBase, Icon, Popover } from '@material-ui/core';
import { ViewAllBidsTooltip } from '../../../Shared/VehicleDetails/components/BidHistorySection/components/ViewAllBidsModal';
import { useState } from 'react';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
`;

const StyledBackButton = styled(ButtonBase)`
  margin-top: auto;
`;

export const EndingBid = ({ vehicle }) => {
  const { bid: amount, bids = [], proxy } = useListVehiclesHighestBid(vehicle);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenPopover = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const formattedBids = bids.map(bid => ({
    id: bid.id,
    bid: bid.amount,
    bidder: bid.bidder?.dealership_name,
    date: convertToLocalTime(bid.created_at, true),
    created_at: bid.created_at,
    admin: bid.admin,
    vehicle_id: bid.vehicle_id
  }));

  const type = (() => {
    if (vehicle.auction && vehicle.auction.type !== AUCTION_TYPES.AUTOAXESS) {
      return 'alternativeOffers';
    }

    if (vehicle.date_end && moment(vehicle.date_end).isBefore(moment())) {
      return 'offers';
    }

    return 'bids';
  })();

  return (
    <Wrapper>
      <NumberFormat displayType="text" prefix="$" value={amount || 0} thousandSeparator />
      {formattedBids.length > 0 && (
        <>
          <StyledBackButton onClick={handleOpenPopover}>
            <Icon>expand_more</Icon>
          </StyledBackButton>
          <Popover
            id="offer-history-popover"
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            marginThreshold={150}
          >
            <ViewAllBidsTooltip
              bids={formattedBids}
              vehicleId={vehicle.id}
              close={handleClosePopover}
              type={type}
              editable
              proxyBid={proxy}
              form={`adminEditBidModalForm-${type}`}
            />
          </Popover>
        </>
      )}
    </Wrapper>
  );
};
